import React, { useMemo } from 'react'

import { Text } from '@/components/ui/text'
import { CommonV2Link } from '@/icons'
import { INetwork, IToken } from '@/types'
import { EVM_NETWORK_KEY, isEvmChain, SUPPORTED_NETWORK } from '@/utils'

import NetworkItem from './NetworkItem'

interface NetworkSelectorProps {
  networks: INetwork[]
  onSelectNetwork: (network: INetwork) => void
  isNetworkDisabled: (network: INetwork) => boolean
  currentNetwork?: INetwork | null
  currentToken?: IToken | null
  selectedNetwork: INetwork | null
  selectedWallet: string | null
  className?: string
}

const NetworkSelector: React.FC<NetworkSelectorProps> = ({
  networks,
  onSelectNetwork,
  isNetworkDisabled,
  currentNetwork,
  currentToken,
  selectedNetwork,
  selectedWallet,
  className,
}) => {
  const sortedNetworks = useMemo(() => {
    // combine all evm to one
    const evmNetwork = networks.find((e) => EVM_NETWORK_KEY.includes(e.networkId as SUPPORTED_NETWORK))

    const filterNetwork = networks.filter((e) => !isEvmChain(e.networkId)).concat(evmNetwork ?? [])

    return filterNetwork.sort((a, b) => {
      const networkIds = [currentToken?.networkId, currentNetwork?.networkId].map((e) =>
        isEvmChain(e) ? evmNetwork?.networkId : e
      )
      if (networkIds.includes(a.networkId)) return -1
      if (networkIds.includes(b.networkId)) return 1
      return 0
    })
  }, [networks, currentToken])

  const hasWallet = !!selectedWallet

  return (
    <div className='space-y-2 flex-1'>
      <div className='text-size-16 flex gap-1 text-white-48'>
        <CommonV2Link className='w-4 min-w-4' />
        <Text size={14} className='my-auto'>
          Chains
        </Text>
      </div>

      <div className='flex flex-col space-y-1'>
        {sortedNetworks.map((network) => {
          const isSelected =
            selectedNetwork?.networkId === network.networkId || selectedNetwork?.networkType === network.networkType
          return (
            <NetworkItem
              className={className}
              key={network.networkId}
              network={network}
              onClick={() => onSelectNetwork(network)}
              isSelected={isSelected}
              isDisabled={isNetworkDisabled(network)}
              hasWallet={hasWallet}
            />
          )
        })}
      </div>
    </div>
  )
}

export default NetworkSelector
